import { IColors } from '../models/ISidebar';

export enum CropStatusEnum {
  HAS_LAND_MERGE_DATA = 'HAS_LAND_MERGE_DATA',
  NOT_HAS_LAND_MERGE_DATA = 'NOT_HAS_LAND_MERGE_DATA',
}

export const COLORS: IColors[] = [
  {
    key: 'ALL',
    name: 'measure.ALL',
    color: 'bg-dark',
  },
  {
    key: 'FILLED',
    name: 'conclusion.filled',
    color: 'bg-green-500',
    has_analysis: true,
  },
  {
    key: 'NOT_FILLED',
    name: 'conclusion.not.filled',
    color: 'bg-gray-500',
    has_analysis: false,
  },
];
export enum MeasureType {
  EMPTY = 'EMPTY',
  ENTRY = 'ENTRY',
  WEIGH_IN = 'WEIGH_IN',
  WEIGH_OUT = 'WEIGH_OUT',
  ANALYSIS = 'ANALYSIS',
  COMPLETE = 'COMPLETE',
}

export enum FIBER_TYPE {
  ONE_A = '1a',
  ONE_B = '1b',
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
}
